import Button from '@material-ui/core/Button';
import { invokePostService } from '../../../store/global/actions'
import { useDispatch, useSelector } from 'react-redux';
import { getBottomDrawerStatus } from '../../../store/global/selectors';
import { useBottomDrawer } from '../../../hooks/useBottomDrawer';

export default function UpdateCancel({ onUpdate, noFloatButton, forceCancel, onCancel, updateDisable, root, content, typesIn, typesNotIn, cancelText, size='medium', hideCancel=false }) {
    const dispatch = useDispatch();
    const bottomDrawer = useBottomDrawer()
    const onClose = () => {
        onCancel();
        if(typesIn || typesNotIn) {
            dispatch(invokePostService('removeLocks', {typesIn, typesNotIn}, []));
        }
    
    }
    
   
    return (
        <>
            {(!bottomDrawer || forceCancel) && !hideCancel &&
                <Button onClick={onClose} variant="contained" className='cancel_btn' id={(`${root|| "form"}_${cancelText ? cancelText : 'Cancel'}`).toLowerCase()} style={{ marginLeft: 10 , textTransform: 'capitalize'}} size={size}>
                    {cancelText ? cancelText : 'Cancel'}
                </Button> 
            }
            <Button onClick={onUpdate} disabled={updateDisable} className={`submit-button ${noFloatButton ? '' : 'update_btn'}`} id={(`${root || "form"}_${content !== undefined ? content : 'Update'}`).toLowerCase()} size={size} color="primary" variant="contained" style={{ marginLeft: 10, textTransform: 'capitalize' }}>
                {content !== undefined ? content : 'Update'}
            </Button>
        </>
    )
}